import ActionTypes from "../store/ActionTypes";
import socketcluster from 'socketcluster-client';
import {storage} from '../utils/map'
import {mapActions} from "vuex";

export const SocketMixin = {
    mounted() {
        this.connectSocketCluster();
    },
    methods: {
        ...mapActions('notify',['notifyCustomerProcess']),
        connectSocketCluster () {
            let socket_endpoint = process.env.VUE_APP_SOCKETCLUSTER_HOST;
            // let socket_endpoint = 'localhost:8898';
            let sc_option = {
                host: socket_endpoint,
                secure: true,
                path: '/ws/',
                autoReconnect: true
            };

            this.$store.state.scClient = socketcluster.connect(sc_option);

            this.$store.state.scClient.on("error", function (err) {
                throw "Socket error - " + err;
            });

            let _this = this;

            this.$store.state.scClient.on("connect", function (status) {
                if (status.isAuthenticated) {
                    // goToMainScreen();

                    let user_info = _this.$store.state.user
                    _this.handleSubscribeChannels(_this, user_info.id)
                } else {
                    // send Authorize
                    let JWT_KEY = 'fptai_messenger_user_jwt';
                    let userJwt = storage.getItem(JWT_KEY);
                    let jwt_user_token = userJwt.user_token;
                    let user_id = userJwt.user.id;
                    // goToLoginScreen();
                    _this.$store.state.scClient.emit('admin_request_authenticate', {
                        user_id: user_id,
                        jwtoken: jwt_user_token
                    }, function (err, data) {
                        if (err) {
                            console.error(err)
                        } else {
                            _this.handleSubscribeChannels(_this, user_id)
                        }
                    });
                }
            });
        },
        handleSubscribeChannels(_this, user_id) {
            // connect channel notification for admin
            // check subscribed > unsubscribe
            if (_this.$store.state.channelsNotiAdmin && _this.$store.state.channelsNotiAdmin.state && _this.$store.state.channelsNotiAdmin.state === "subscribed") {
                _this.$store.state.channelsNotiAdmin.destroy();
            }

            let noti_admin_channel_name = _this.$const.SOCKETCLUSTER_NOTI_CHANNEL.USER + user_id;
            _this.$store.state.channelsNotiAdmin = _this.$store.state.scClient.subscribe(noti_admin_channel_name);
            _this.$nextTick(function () {
                if (_this.$store.state.channelsNotiAdmin) {
                    _this.$store.state.channelsNotiAdmin.watch(data => {
                        _this.$store.commit(ActionTypes.NOTIFY_ADMIN_CHANNELS, data);
                    })
                }
            });

            const bot_code = _this.$route.params.bot_code || _this.$route.params.botCode;
            if (bot_code) {
                // connect channels notification of bot
                // check if subscribed, > unsubscribe
                if (_this.$store.state.channelsNotiBot && _this.$store.state.channelsNotiBot.state && _this.$store.state.channelsNotiBot.state === "subscribed") {
                    _this.$store.state.channelsNotiBot.destroy();
                }
                // connect channels notification
                let noti_bot_channel_name = _this.$const.SOCKETCLUSTER_NOTI_CHANNEL.APP + bot_code;
                _this.$store.state.channelsNotiBot = _this.$store.state.scClient.subscribe(noti_bot_channel_name);

                _this.$nextTick(function () {
                    if (_this.$store.state.channelsNotiBot) {
                        _this.$store.state.channelsNotiBot.watch(data => {
                            _this.$store.commit(ActionTypes.NOTIFY_CUSTOMER_CHANNELS, data);
                            _this.notifyCustomerProcess(data)
                        })
                    }
                });
            }

            // subscribe sender channel
            if (_this.$route.params.senderId || _this.$route.params.sender_id) {
                // connect channels with sender
                _this.$refs.v_chat_view.connectSocket();
            }

            // subscribe admin channel
            if (_this.$refs.v_staff_chat && _this.$refs.v_staff_chat.showChatView) {
                _this.$refs.v_staff_chat.connectSocket();
            }
        }
    }
};
